import(/* webpackMode: "eager" */ "/vercel/path0/ui/app/template.tsx");
